import { Box } from '@mui/material';
import QuestionComponent from 'components/QuestionComponent/QuestionComponent';
import { useChangeFromMedia } from 'common/helpers';
import CustomInfoBlock from 'components/UI/CustomInfoBlock/CustomInfoBlock';
import { useState } from 'react';
import classes from './StudentQuestions.module.scss';


const StudentQuestions = ({ data, title }) => {

  const swiperOpts = useChangeFromMedia(
    { slidesPerView: 1.26, spaceBetween: 40 },
    { slidesPerView: 1 },
    { slidesPerView: 1.191, spaceBetween: 20 },
    { slidesPerView: 1 },
    { slidesPerView: 1 },
  );
  const stylesForMobile = useChangeFromMedia({}, {
    width: '225px',
    fontSize: '30px',
  }, {}, {});
  const [ topHeights, setTopHeights ] = useState(null);
  const addHeights = (height) => {
    setTopHeights(prev => {
      if (prev > height) return prev;
      return height;
    });
  };
  const container = useChangeFromMedia(false, true, false, true, true);
  if (!data?.length) return null;
  return (
    <Box className={classes.main}>
      <CustomInfoBlock
        text={title}
        swiperOpts={swiperOpts}
        stylesForMobile={stylesForMobile}
        isButtons={true}
        myClass={classes.blocks}
        isContainer={container}
      >
        {data?.map((item, idx) => (
          <QuestionComponent
            addHeights={addHeights}
            key={idx}
            height={topHeights}
            question={item?.question}
            answer={item?.answer}
          />
        ))}
      </CustomInfoBlock>
    </Box>
  );
};

export default StudentQuestions;
